import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { serverServicesAPI } from '../services/api';
import ServiceActionsTable from './ServiceActionsTable';

// The last stops and starts on this server (any service on it), read only; shown to everyone who can open the service dialog. `refresh` changes to reload.
function RecentServiceActions({ customerCode, host, refresh }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let current = true;
    serverServicesAPI.actions(customerCode, host).then((r) => { if (current) setRows(r.data); }).catch(() => { if (current) setRows([]); });
    return () => { current = false; };
  }, [customerCode, host, refresh]);
  if (!rows || rows.length === 0) return null;
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">Recent stops and starts on this server</Typography>
      <ServiceActionsTable rows={rows.map((r) => ({ ...r, took_seconds: r.completed_at ? Math.round((new Date(r.completed_at) - new Date(r.requested_at)) / 1000) : null }))} showHost={false} />
    </Box>
  );
}

export default RecentServiceActions;
